const formatSearchValue = (value: unknown): string => {
  if (typeof value === 'boolean') {
    return value ? '1' : '0'
  }
  return String(value)
}

export const urlSearchformat = (
  filters: Record<string, unknown> | undefined,
): string => {
  if (filters === undefined) {
    return ''
  }

  const searchParams = new URLSearchParams()
  for (const [key, value] of Object.entries(filters)) {
    if (value !== undefined) {
      searchParams.append(key, formatSearchValue(value))
    }
  }

  return `${searchParams.toString()}`
}

export const formatNumber = (figure: number | string) => {
  const formatNumber = (n: number) =>
    new Intl.NumberFormat('es-ES', {
      minimumFractionDigits: 2,
      signDisplay: 'auto',
    }).format(n)

  return typeof figure === 'number'
    ? formatNumber(figure as number)
    : typeof figure === 'string'
    ? formatNumber(Number(figure) as number)
    : figure
}

export const formatPrice = (n: number) =>
  new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(
    n,
  )

const utf8_to_b64 = (str: string) => {
  return window.btoa(unescape(encodeURIComponent(str)))
}
export const encode = (value: any) => utf8_to_b64(JSON.stringify(value))

const b64_to_utf8 = (str: string) => {
  return decodeURIComponent(escape(window.atob(str)))
}
export const decode = (value: string) => JSON.parse(b64_to_utf8(value))

// returned format: dd/MM/yy
export const formatShortDate = (dateStr: string) =>
  new Date(dateStr).toLocaleString('es-ES', {
    month: '2-digit',
    day: '2-digit',
    year: '2-digit',
  })

// returned format: dd/MM/yyyy
export const formatLongDate = (dateStr: string) =>
  new Date(dateStr).toLocaleString('es-ES', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
  })

// returned format: 'dd/MM/yyyy HH:mm'
export const formatFullLongDate = (dateStr: string) =>
  new Date(dateStr)
    .toLocaleString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
      timeZone: 'UTC',
    })
    .replace(',', '')

// returned format: d mon (1 ene)
export const formatShortTextDate = (dateStr: string) =>
  new Date(dateStr).toLocaleString('es-ES', {
    month: 'short',
    day: 'numeric',
  })

const capitalize = (str: string) =>
  str.charAt(0).toUpperCase().concat(str.slice(1))
// returned format: month year (Enero 2024)
export const formatMonthTextDate = (dateStr: string) => {
  const month = capitalize(
    new Date(dateStr).toLocaleString('es-ES', {
      month: 'long',
    }),
  )
  const year = new Date(dateStr).getFullYear()
  return `${month} ${year}`
}

export const formatHour = (dateStr: string) =>
  new Date(dateStr).toLocaleString('es-ES', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  })

// returned format: MM/yyyy
export const formatMonthDate = (dateStr: string) =>
  new Date(dateStr).toLocaleString('es-ES', {
    month: '2-digit',
    year: 'numeric',
  })
